import { useEffect } from "react";
import { useDispatch, useStore  } from 'react-redux';
import {
  setDropbox,
} from "../../../../actions/index";

const useMidDropBoxV3 = (active, isOver) => {
  const store = useStore(); // const dropboxElement = useSelector(state => state.dropboxElement);
  const dispatch = useDispatch();

  useEffect(() => {
    const dropboxElement = store.getState().dropboxElement;
    const el = document.getElementById(active);
    if (el) {
      if (isOver) {
        if (dropboxElement !== null && dropboxElement !== undefined && dropboxElement !== el)
          dropboxElement.style.opacity = 0;    
        dispatch(setDropbox(el));
        el.style.opacity = 1;
      } else {
        if (dropboxElement !== null && dropboxElement !== undefined && dropboxElement !== el)
          el.style.opacity = 0;
      }
    }
  }, [active, isOver, dispatch, store/*, dropboxElement*/]);

  return null;
};

export default useMidDropBoxV3;
